import axios from 'axios'
import axiosRetry from 'axios-retry'
import * as Sentry from "@sentry/vue";

axiosRetry(axios, { retries: 5 })

const headers = {
  proxy: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  payments: {
    "Content-Type": "application/json",
    Authorization: process.env.VUE_APP_TOKEN,
  },
  stripe: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  braintree: {
    'Content-Type': 'application/json'
  }
}
const proxyMetrics = axios.create({
  baseURL: `${process.env.VUE_APP_URL}/track.php/`,
  headers: {
    post: headers.proxy,
    get: headers.proxy,
    patch: headers.proxy,
    delete: headers.proxy
  }
})

proxyMetrics.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

proxyMetrics.interceptors.response.use(
  (config) => {
    return config
  },
  (error) => {
    if(error.message === 'Network Error' && !error.response) {
      return true
    }
    return Promise.reject(error)
  }
)

const paymentsRequests = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL + '/api/',
  headers: {
    post: headers.payments,
    get: headers.payments,
    patch: headers.payments,
    delete: headers.payments
  }
})

paymentsRequests.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => {
    Sentry.captureException(error);
    return Promise.reject(error)
  }
)

paymentsRequests.interceptors.response.use(
  (config) => {
    return config
  },
  (error) => {
    Sentry.captureException(error);
    if(error.message === 'Network Error' && !error.response) {
      return true
    }
    return Promise.reject(error)
  },
)

const stripeRequests = axios.create({
  baseURL: 'https://api.stripe.com/v1/',
  headers: {
    post: headers.stripe,
    get: headers.stripe,
    patch: headers.stripe,
    delete: headers.stripe
  }
})

const braintreeRequests = axios.create({
  baseURL: 'https://api.sandbox.braintreegateway.com/merchants/95dqhww6s625y25h/client_api/v1/',
  headers: {
    post: headers.braintree,
    get: headers.braintree,
    patch: headers.braintree,
    delete: headers.braintree
  }
})

export { proxyMetrics, paymentsRequests, stripeRequests, braintreeRequests }
